export enum ApiErrorCode {
  BANNED_USER = 1002,
  ACCOUNT_DELETION_UNDER_REVIEW = 1053,
  RATE_LIMIT_DATA_REQUEST = 1055,
  NAFATH_BUSINESS_ERROR = 1100,
}
